import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { Employee } from "../types/employee.types";
import EmployeeOverviewContext from "./EmployeeOverviewContext";
import { getDocumentTitle } from "utils/helpers";
import { getEmployee } from "../services/EmployeeService";
import Section from "./Section";

const EmployeeOverview = () => {
  document.title = getDocumentTitle("Employee Details");
  const { id } = useParams();
  const [employee, setEmployee] = useState<Employee | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        if (id) {
          const response = await getEmployee(Number(id));
          if (response.success) {
            setEmployee(response.data);
          }
        }
      } catch (err) {
        console.warn(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployee();
  }, [id]);

  if (loading) return <PageLoadingSpinner message="Loading employee..." />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Employee Details"
          pageTitle="HR Management"
          items={[{ label: "Employees", path: "/employees" }]}
        />
        <EmployeeOverviewContext.Provider value={{ employee }}>
          <Section />
        </EmployeeOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default EmployeeOverview;
